<template>
  <div class="px-5 w-1/2">
    <h3 class="font-medium text-xl text-indigo-700">{{ $lang.app.COMMENTS }}</h3>
    <div v-for="comment in comments" :key="comment.id" class="my-3">
      <div class="w-full">
        <div class="flex justify-between items-baseline">
          <h4 class="font-medium">{{ $lang.app[this.returnTypeGetLabelRefByValue(comment.type)] }}</h4>
          <div class="text-sm text-blue-700">{{ $moment(comment.createdAt).format('DD.MM.YYYY HH:mm') }}</div>
        </div>
        <div class="border border-blue-200 bg-white px-2 pt-1 pb-2">
          <p class="whitespace-pre-line px-2 pt-1 pb-2">{{ comment.comment }}</p>
          <div class="md:w-2/2">
            <div v-for="commentFile in comment.documentCommentFiles"  :key="commentFile.id"
                 class="w-1/3 cursor-pointer border border-green-400 rounded flex p-2 items-center"
                 @click="openFile(comment.id, commentFile.id)">
              <PdfIcon class="w-8 h-8 flex-shrink-0"/>
              <div class="ml-2 text-sm text-gray-600 leading-tight overflow-hidden"
                   :title="commentFile.files.filename">
                {{ commentFile.files.filename }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getLabelRefByValue as returnTypeGetLabelRefByValue} from "../../../../helpers/constants/returnTypes";
import {getCommentFile} from "@/api/applicant/application";

export default {
  name: "ApplicantApplicationCommentsDetail",
  props: {
    application: Object,
  },
  data() {
    return {
      comments: this.application.comments
    };
  },
  methods: {
    returnTypeGetLabelRefByValue,
    openFile(commentId, commentFileId) {
      this.$emitter.emit('open-loader-modal')
      getCommentFile(commentId, commentFileId)
          .then((response) => {
            this.$emitter.emit('open-file-modal', response.data)
          })
          .catch((error) => {
            this.$snotify.error(error);
          })
          .finally(() => {
            this.$emitter.emit('close-loader-modal')
          });
    },
  }
};
</script>
